import { DESCRIPTION, NAME_TEXT } from '../../../../constants/common-labels.constants';
import { FormVmItemConfigType } from '../../../../infrastructure/form-viewmodel-controller';
import { trimSpacesLeft } from '../../../../modules/formatters';
import { plainText } from '../../../../modules/validators';
import { ADD_ORDER_FORM_CONFIG } from '../../../_events/_manage-event/shared/salesforce-order/add-salesforce-order.fields';
import { ORDER_TEMPLATE_FORM_FIELD_KEYS } from '../../../_events/_manage-event/shared/salesforce-order/order-field-dependencies';

export const TEMPLATE_NAME_KEY = 'name';
export const TEMPLATE_DESCRIPTION_KEY = 'templateDescription';

const templateHeaderConfig: FormVmItemConfigType[] = [
    {
        name: TEMPLATE_NAME_KEY,
        labelDescriptor: NAME_TEXT,
        defaultValue: '',
        validators: [plainText.required, plainText.maxLength.short],
        formatters: [trimSpacesLeft],
    },
    {
        name: TEMPLATE_DESCRIPTION_KEY,
        labelDescriptor: DESCRIPTION,
        defaultValue: '',
        validators: [plainText.maxLength.long],
        formatters: [trimSpacesLeft],
    },
];

export const ORDER_TEMPLATE_FORM_CONFIG: FormVmItemConfigType[] = [
    ...templateHeaderConfig,
    ...ADD_ORDER_FORM_CONFIG.filter(field => ORDER_TEMPLATE_FORM_FIELD_KEYS.has(field.name)),
];

export const ORDER_TEMPLATE_CONFIGURED_KEYS: ReadonlySet<string> = new Set(
    ORDER_TEMPLATE_FORM_CONFIG.map(field => field.name),
);
